
const placeSchema = ({
  name,
  description,
  url,
  address,
  telephone,
  image,
}) => ({
  "@context": "https://schema.org",
  "@type": "Place",
  "@id": `${url}#place`,
  name,
  description,
  url,
  ...(address && {
    address: {
      "@type": "PostalAddress",
      ...address,
    },
  }),
  ...(telephone && { telephone }),
  ...(image && { image }),
  containedInPlace: {
    "@id": "https://irisimpulse.com/#organization",
  },
});

export default placeSchema;
